import {
  getAppOrigin,
  getDeployEnv,
  getVersion,
} from "../../../environment.js";

/**
 * The origin handed to embedded MX dashboards (Call Assistant, POS dashboard)
 * as `msys_url`. Prefers the runtime-config value, which is correct on every
 * platform including native Capacitor builds (where `window.location.hostname`
 * is always "localhost"). Falls back to `window.location.origin` when the
 * config value isn't populated yet for this env.
 */
export function resolveMsysUrl(): string {
  if (getDeployEnv() === "local") {
    return "";
  }
  const appOrigin = getAppOrigin();
  if (appOrigin) {
    return appOrigin;
  }
  return window.location.hostname !== "localhost" ? window.location.origin : "";
}

/**
 * Sets the query parameters every embedded MX dashboard expects:
 * `contractor_id`, `user_id`, `lang`, `msys_url` (removed when unresolvable)
 * and `v` (removed when no version is known).
 */
export function setMxDashboardSearchParams(
  searchParams: URLSearchParams,
  {
    organisationId,
    userId,
    locale,
  }: { organisationId: string; userId: string; locale: string | undefined }
): URLSearchParams {
  searchParams.set("contractor_id", organisationId);
  searchParams.set("user_id", userId);
  searchParams.set("lang", locale?.split("-").at(0)?.toLowerCase() ?? "de");
  const msysUrlValue = resolveMsysUrl();
  if (msysUrlValue) {
    searchParams.set("msys_url", msysUrlValue);
  } else {
    searchParams.delete("msys_url");
  }
  const version = getVersion();
  if (version) {
    searchParams.set("v", version);
  } else {
    searchParams.delete("v");
  }
  return searchParams;
}
